import React from 'react';
import PropTypes from 'prop-types';
import { Text, CenteredContainer, Title, Type } from '@nerdwallet/currency';
import { ElementImpression } from '@nerdwallet/nw-client-lib/tracking';
import Image from '@nerdwallet/react-image';

const ReasonsToBelieve = ({ eyebrow, title, bullets, imageUrl }) => (
  <ElementImpression
    elementDomType="div"
    elementName="ReasonsToBelieve"
    id="reasons-to-believe"
  >
    <CenteredContainer className="reasons">
      <div className="reasons__content">
        <div className="reasons__copy">
          <Type light uppercase size={1} bold>
            {eyebrow}
          </Type>
          <Title size="small" className="reasons__heading" component="h2">
            {title}
          </Title>
          <div className="reasons__bullets">
            {bullets.map((bullet) => (
              <div className="reasons__bullet" key={bullet.title}>
                <div className="reasons__bulletTitle">
                  <Text size="large" bold>
                    {bullet.title}
                  </Text>
                </div>
                <Text>{bullet.content}</Text>
              </div>
            ))}
          </div>
        </div>
        {imageUrl ? (
          <div className="reasons__image">
            <Image
              src={imageUrl}
              alt=""
              naturalWidth={1206}
              naturalHeight={1344}
              backgroundColor="transparent"
              role="presentation"
              lazy
            />
          </div>
        ) : null}
      </div>
    </CenteredContainer>
  </ElementImpression>
);

ReasonsToBelieve.propTypes = {
  bullets: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      content: PropTypes.string,
    })
  ),
  eyebrow: PropTypes.string,
  imageUrl: PropTypes.string,
  title: PropTypes.string,
};

ReasonsToBelieve.defaultProps = {
  eyebrow: 'You got this',
  title: 'Everything you need — totally free',
  bullets: [],
};

export default ReasonsToBelieve;
